export enum SortDirection {
    ASC,
    DESC,
    DEFAULT,
}
export interface Sort {
    columnId: string;
    order: SortDirection;
    columnType?: string;
}
